import { setDependentAnswerPreset, setDirectAnswerPreset } from "../..";
import { GLOBAL_PRESETS } from "../presets";
import { TAnswerFlow } from "../types";
import * as beautyUtils from "../utils";

export const LOREAL_ANSWER_FLOWS: Record<number, TAnswerFlow> = {
  1: setDirectAnswerPreset(
    undefined,
    "EYE CATEGORY - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the L'Oreal EYE category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].loreal.eye_oos_before()
  ),
  2: setDirectAnswerPreset(
    undefined,
    "FACE Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the L'Oreal FACE category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].loreal.face_oos_before()
  ),
  3: setDirectAnswerPreset(
    undefined,
    "LIP Category - UPON ARRIVAL, BEFORE zoning or stocking, please count how many items are out of stock in the L'Oreal LIP category",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].loreal.lip_oos_before()
  ),
  4: setDirectAnswerPreset(
    undefined,
    "What is the total number of pieces of L'Oreal Cosmetics you stocked today",
    "text",
    (storeLabel) => GLOBAL_PRESETS[storeLabel].loreal.total_stocked()
  ),
  5: setDependentAnswerPreset(
    undefined,
    "L'OREAL EYE: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [1],
    beautyUtils.getAfterOOSCount
  ),
  6: setDependentAnswerPreset(
    undefined,
    "L'OREAL FACE: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [2],
    beautyUtils.getAfterOOSCount
  ),
  7: setDependentAnswerPreset(
    undefined,
    "L'OREAL LIP: After Zoning/Stocking/Merchandising, what is the Total # of Out Of Stocks during this visit",
    "text",
    [3],
    beautyUtils.getAfterOOSCount
  ),
  8: setDependentAnswerPreset(
    undefined,
    "L'OREAL EYE: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [5],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  9: setDependentAnswerPreset(
    undefined,
    "L'OREAL FACE: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [6],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  10: setDependentAnswerPreset(
    undefined,
    "L'OREAL LIP: How many Out Of Stock items with 0 in the backroom show an on hand count (on hand in parentheses) greater than 0",
    "text",
    [7],
    beautyUtils.getOOSWithOnHandsGreaterThanZero
  ),
  11: setDependentAnswerPreset(
    "L'Oreal Cosmetics",
    "Select why 0 Items needed a count correction",
    "text",
    [8, 9, 10],
    beautyUtils.getWhyZeroItemsNeededCountCorrection
  ),
  11.5: setDependentAnswerPreset(
    "L'Oreal Cosmetics",
    "Confirm 0 out of stock items need a count correction",
    "radio",
    [8, 9, 10],
    (dependencyAnswers) => {
      if (beautyUtils.getWhyZeroItemsNeededCountCorrection(dependencyAnswers) === null) return null;
      return "No out of stock items needzed a count correction";
    }
  ),
  12: setDirectAnswerPreset(
    "L'Oreal Cosmetics",
    "Are there shelf labels missing on the L'Oreal Cosmetic POG",
    "radio",
    () => "No shelf labels are missing from the L'Oreal POG"
  ),
  13: setDependentAnswerPreset(
    "L'Oreal Cosmetics Count Corrections",
    "Did a Team Lead assist you during your service to correct any L'Oreal Cosmetics EYE or FACE or LIP incorrect counts for out of stock items in the Inventory Audit",
    "radio",
    [8, 9, 10],
    beautyUtils.getDidATeamMemberAssistYouWithUpdatingOnHands
  ),
  14: setDependentAnswerPreset(
    undefined,
    "L'Oreal EYE: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [8],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
  15: setDependentAnswerPreset(
    undefined,
    "L'Oreal FACE: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [9],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
  16: setDependentAnswerPreset(
    undefined,
    "L'Oreal LIP: What is the total number DPCIs in which the counts WERE CORRECTED in the INVENTORY AUDIT in your presence during this visit",
    "text",
    [10],
    (dependencyAnswers) => dependencyAnswers[0]
  ),
};
